import { Box, BoxProps, ColorOptions, Icon, Spacer, Text, TextProps } from '@jfs/ui-new'
import { flatten } from 'lottie-colorify'
import { FC } from 'react'
import Lottie from 'react-lottie'
import { TouchableOpacity } from 'react-native'
import { isValidColorCode } from '../../utils'
import { staticStrings, testIds } from '../../utils/string'
const loader = require('../../assets/images/pg_loader.json')
type EmptyCompProps = {
  state: 'pending' | 'fulfilled' | 'rejected' | undefined
  message?: string
  show?: boolean
  onRetry: () => void
  theme?: any
}

interface EmptyVewProps {
  onRetry: () => void
  isLoading: boolean
  error?: any
  loadingMessage: string
  emptyMessage?: string
  theme?: any
}

const EmptyView: FC<EmptyVewProps> = ({
  onRetry,
  isLoading,
  error,
  loadingMessage,
  emptyMessage = '',
  theme,
}: EmptyVewProps) => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: isValidColorCode(theme?.brandColor) ? flatten(theme?.brandColor, loader) : loader,
  }
  const message = error
    ? emptyMessage ?? staticStrings.somethingwentWrong
    : isLoading
    ? loadingMessage
    : emptyMessage ?? staticStrings.somethingwentWrong
  return (
    <Box {...styles.centerAlignment(theme)}>
      {isLoading && !error && (
        <>
          <Lottie options={defaultOptions} height={60} width={60} />
          <Spacer size={16} />
        </>
      )}
      <Text {...styles.titleEmpty(theme)}>{message}</Text>
      {!!error && (
        <TouchableOpacity testID="buttonTestID" onPress={onRetry}>
          <Spacer size={8} />
          <Icon id="ICON_REFRESH" color={theme?.bodyTextColor as ColorOptions} />
        </TouchableOpacity>
      )}
    </Box>
  )
}

const EmptyComp = ({ state, onRetry, message = '', show = false, theme }: EmptyCompProps) => {
  // if (state === 'fulfilled') return null

  return (
    <Box {...styles.centerAlignment(theme)} testID={testIds.emptyView}>
      <EmptyView
        isLoading={state === 'pending' || show}
        onRetry={onRetry}
        loadingMessage="Loading"
        error={state === 'rejected'}
        emptyMessage={message}
        theme={theme}
      />
    </Box>
  )
}

const styles = {
  centerAlignment: (theme: any) =>
    ({
      flex: 1,
      width: '100%',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: theme?.bodyBgColor as ColorOptions,
    } as BoxProps),
  titleEmpty: (theme: any) =>
    ({
      color: theme?.brandColor as ColorOptions,
      fontSize: 12,
      fontWeight: '500',
      padding: 16,
      textAlign: 'center',
      fontFamily: 'jioType-Medium',
    } as TextProps),
}

export default styles

export { EmptyComp as EmptyView }
